module.exports = __webpack_public_path__ + "img/modelshow05.ef236fc0.png";